import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qa-select-verse-range" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "qa-svr-title" }, "Final verse", -1)
const _hoisted_3 = { class: "qa-svr-last-verse" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Rough")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Fine")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Begin")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderText = _resolveComponent("PlaceholderText")!
  const _component_Range = _resolveComponent("Range")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.fineTooltip) + " ", 1),
      (!_ctx.fineTooltip)
        ? (_openBlock(), _createBlock(_component_PlaceholderText, {
            key: 0,
            length: 4
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Range, {
      modelValue: _ctx.selectedRoughIndex,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRoughIndex) = $event)),
      tooltip: _ctx.roughTooltip,
      min: 0,
      max: _ctx.verses.length - 1
    }, {
      label: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["modelValue", "tooltip", "max"]),
    (_ctx.showFine)
      ? (_openBlock(), _createBlock(_component_Range, {
          key: 0,
          modelValue: _ctx.selectedFineIndex,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFineIndex) = $event)),
          tooltip: _ctx.fineTooltip,
          min: 0,
          max: _ctx.fineVerses.length - 1
        }, {
          label: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue", "tooltip", "max"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Button, {
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('select', _ctx.finalSelectedIndex)), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}